<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterAuthorizeMapping"
              :editedCustomerIndex="-1"
              :customerName="'quotation_customer_number'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              label="車牌"
              v-model="filterAuthorizeMapping.LicensePlate"
              @input="getAuthorizeMapping"
            ></v-text-field>
          </v-col>
          <v-col>
            <item-autocomplete-filter
              :fatherEditedItem="filterAuthorizeMapping"
              :editedItemIndex="-1"
              :itemName="'quotation_item_number'"
              @setEditedItem="setEditedItem"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="authorizeMappingDataTableHeaders"
      :items="authorizeMappingList"
      class="elevation-1 mt-5"
      :loading="isLoadingAuthorizeMapping"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
      :search="search"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>授權對應品項表</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('common_search')"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-dialog v-model="isShowEditAuthorizeMappingDialog" max-width="800px" persistent>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ dialogTitleHeader }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <ValidationObserver ref="authorizeMapping">
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedAuthorizeMapping.ItemNumber"
                          label="品號"
                          disabled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedAuthorizeMapping.ItemName"
                          label="品名"
                          disabled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedAuthorizeMapping.ItemSerialNumber"
                          label="機器序號"
                          disabled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedAuthorizeMapping.AuthorizeItemSerialNumber"
                          label="授權序號"
                          disabled
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-autocomplete
                          :items="gmTypeList"
                          item-text="Name"
                          item-value="Type"
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_results')"
                          v-model="editedAuthorizeMapping.GmServerType"
                          label="GM"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedAuthorizeMapping.CustomerNumber"
                          disabled
                          :label="$t('quotation_customer_number')"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedAuthorizeMapping.CustomerName"
                          disabled
                          :label="$t('quotation_shortname')"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedAuthorizeMapping.CustomerFullName"
                          disabled
                          :label="$t('quotation_full_name')"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedAuthorizeMapping.LicensePlate"
                          disabled
                          :label="$t('quotation_license_plate')"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field v-model="turnDoneDate" disabled label="完工時間">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedAuthorizeMapping"
                  :disabled="isAllTextFieldDisable"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="saveEditedAuthorizeMapping"
                  :loading="isLoadingSaveBtn"
                >
                  {{ $t('common_save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isLoadingSaveBtn="isLoadingDeleteBtn"
            :isShowDeleteDialog="isShowDeleteAuthorizeMappingDialog"
            :deleteMessage="'common_delete'"
            @closeDelete="closeDeleteAuthorizeMapping"
            @confirmDelete="confirmDeleteAuthorizeMapping"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditAuthorizeMappingBtn(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn icon @click="isShowDeleteAuthorizeMappingBtn(item)">
          <v-icon small>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.GmServerType`]="{ item }">
        {{ turnFormType(item.GmServerType) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { HttpAuthorizeMapping } from '@/js/http-Manager'
import { GmServerType } from '@/js/GmServerType'
import DeleteDialog from '@/components/DeleteDialog.vue'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import ItemAutocompleteFilter from '@/components/ItemAutocompleteFilter.vue'

export default {
  name: 'AuthorizeMapping',
  components: { DeleteDialog, CustomerAutocompleteFilter, ItemAutocompleteFilter },
  data: () => ({
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isShowEditAuthorizeMappingDialog: false,
    authorizeMappingList: [],
    editedAuthorizeMappingIndex: -1,
    search: '',
    editedAuthorizeMapping: {
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      ItemSerialNumber: '',
      AuthorizeItemSerialNumber: '',
      GmServerType: 0,
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      DoneTime: 0
    },
    defaultAuthorizeMapping: {
      ItemId: '',
      ItemNumber: '',
      ItemName: '',
      ItemSerialNumber: '',
      AuthorizeItemSerialNumber: '',
      GmServerType: 0,
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      DoneTime: 0
    },
    isLoadingAuthorizeMapping: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    isShowDeleteAuthorizeMappingDialog: false,
    isLoadingDeleteBtn: false,
    isDeleteBtnDisable: false,
    gmTypeList: [],
    totalRows: 0,
    isUpdateEventTotal: false,
    filterAuthorizeMapping: {
      CustomerId: '',
      LicensePlate: '',
      ItemId: '',
      AuthorizeItemId: ''
    }
  }),
  async mounted () {
    await this.getTotalCount()
    await this.getAuthorizeMapping()
    await this.getGmTypes()
  },
  computed: {
    authorizeMappingDataTableHeaders () {
      return [
        {
          text: '品號',
          align: 'start',
          value: 'ItemNumber'
        },
        {
          text: '品名',
          align: 'start',
          value: 'ItemName'
        },
        {
          text: '機器序號',
          align: 'start',
          value: 'ItemSerialNumber'
        },
        {
          text: '授權序號',
          align: 'start',
          value: 'AuthorizeItemSerialNumber'
        },
        {
          text: 'GM',
          align: 'start',
          value: 'GmServerType'
        },
        {
          text: '客戶代號',
          align: 'start',
          value: 'CustomerNumber'
        },
        {
          text: '客戶簡稱',
          align: 'start',
          value: 'CustomerName'
        },
        {
          text: '客戶全名',
          align: 'start',
          value: 'CustomerFullName'
        },
        {
          text: '車牌',
          align: 'start',
          value: 'LicensePlate'
        },
        {
          text: this.$t('common_edit'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    turnFormTypeName () {
      return GmServerType.GmServerTypeName(this.editedAuthorizeMapping.Type)
    },
    dialogTitleHeader () {
      return this.editedAuthorizeMappingIndex === -1
        ? this.$t('common_new')
        : this.$t('common_edit')
    },
    turnDoneDate () {
      return this.convertToDateTimeFormat(this.editedAuthorizeMapping.DoneTime)
    }
  },
  methods: {
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    setTypeAutocomplete (event) {
      this.$refs.typeAutocomplete.isMenuActive = false
      this.$refs.typeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    async getGmTypes () {
      let response = await HttpAuthorizeMapping.GetGmTypes()
      this.gmTypeList = response.status === 200 ? response.data.Data : []
    },
    turnFormType (val) {
      return GmServerType.GmServerTypeName(val)
    },
    async getTotalCount () {
      if (this.isUpdateEventTotal) {
        let param = {
          CustomerId: '',
          LicensePlate: '',
          ItemId: '',
          AuthorizeItemId: ''
        }
        let response = await HttpAuthorizeMapping.GetAuthorizeMappingCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getAuthorizeMapping(val)
    },
    async setFilterCustomer (val) {
      this.filterAuthorizeMapping.CustomerId = val.Id
      this.filterAuthorizeMapping = JSON.parse(JSON.stringify(this.filterAuthorizeMapping))
      await this.getTotalCount()
      await this.getAuthorizeMapping()
    },
    async setEditedItem (val) {
      this.filterSerialNumber.ItemId = val.Id
      this.filterAuthorizeMapping.ItemNumber = val.Number
      this.filterAuthorizeMapping = JSON.parse(JSON.stringify(this.filterAuthorizeMapping))
      await this.getTotalCount()
      await this.getAuthorizeMapping()
    },
    async getAuthorizeMapping (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.getTotalCount()
      }
      this.isUpdateEventTotal = true
      this.isLoadingAuthorizeMapping = true
      let param = {
        CustomerId: '',
        LicensePlate: '',
        ItemId: '',
        AuthorizeItemId: '',
        ItemsPerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy[0],
        SortDesc: typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortBy[0]
      }
      let response = await HttpAuthorizeMapping.GetAuthorizeMapping(param)
      this.isLoadingAuthorizeMapping = false
      this.authorizeMappingList = response && response.status === 200 ? response.data.Data : []
    },
    isShowEditAuthorizeMappingBtn (item) {
      this.editedAuthorizeMappingIndex = this.authorizeMappingList.indexOf(item)
      this.editedAuthorizeMapping = JSON.parse(JSON.stringify(item))
      this.isShowEditAuthorizeMappingDialog = true
    },
    closeEditedAuthorizeMapping () {
      this.isShowEditAuthorizeMappingDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false

      this.$nextTick(() => {
        this.editedAuthorizeMapping = JSON.parse(JSON.stringify(this.defaultAuthorizeMapping))
        this.editedAuthorizeMappingIndex = -1
      })
    },
    async saveEditedAuthorizeMapping () {
      const isValid = await this.$refs.authorizeMapping.validate()
      if (isValid) {
        this.isLoadingSaveBtn = true
        this.isAllTextFieldDisable = true
        this.isLoadingAuthorizeMapping = true
        if (this.editedAuthorizeMappingIndex !== -1) {
          await HttpAuthorizeMapping.UpdateAuthorizeMapping(this.editedAuthorizeMapping)
        } else {
          await HttpAuthorizeMapping.AddAuthorizeMapping(this.editedAuthorizeMapping)
        }
        await this.getAuthorizeMapping()
        this.closeEditedAuthorizeMapping()
      }
    },
    isShowDeleteAuthorizeMappingBtn (item) {
      this.editedAuthorizeMappingIndex = this.authorizeMappingList.indexOf(item)
      this.isShowDeleteAuthorizeMappingDialog = true
    },
    async confirmDeleteAuthorizeMapping () {
      this.isLoadingDeleteBtn = true
      this.isDeleteBtnDisable = true
      this.isLoadingAuthorizeMapping = true
      await HttpAuthorizeMapping.DeleteAuthorizeMapping(
        this.authorizeMappingList[this.editedAuthorizeMappingIndex].Id
      )
      this.isLoadingDeleteBtn = false
      this.isDeleteBtnDisable = false
      this.isLoadingAuthorizeMapping = false
      await this.getAuthorizeMapping()
      this.closeDeleteAuthorizeMapping()
    },
    closeDeleteAuthorizeMapping () {
      this.isShowDeleteAuthorizeMappingDialog = false
      this.$nextTick(() => {
        this.editedAuthorizeMappingIndex = -1
      })
    }
  }
}
</script>
